import { Route, Routes } from "react-router";
import { NotFound } from "../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../common/constants";
import { Permission } from "../../common/security/enums";
import PageWithPermission from "../auth/components/PageWithPermission";
import { RealtyCalcContainer } from "./calcs/realty/containers/RealtyCalcContainer";
import { TravelCalcContainer } from "./calcs/travel/containers/TravelCalcContainer";
import { VehicleCalcContainer } from "./calcs/vehicle/containers/VehicleCalcContainer";
import { CalcDraftListContainer } from "./drafts/containers/CalcDraftListContainer";
import { CALC_ROUTE_PATHS } from "./paths";
import { CalcRecordsContainer } from "./records/containers/CalcRecordsContainer";

const routes = () => (
  <Routes>
    <Route
      path={CALC_ROUTE_PATHS.vehicle.path}
      element={
        <PageWithPermission
          component={<VehicleCalcContainer />}
          permissions={[Permission.MTPL_CALCULATE, Permission.CRASH_CALCULATE]}
          anyPermission
        />
      }
    />

    <Route
      path={CALC_ROUTE_PATHS.travel.path}
      element={<PageWithPermission component={<TravelCalcContainer />} permissions={[Permission.TRAVEL_CALCULATE]} />}
    />

    <Route
      path={CALC_ROUTE_PATHS.realty.path}
      element={<PageWithPermission component={<RealtyCalcContainer />} permissions={[Permission.REALTY_CALCULATE]} />}
    />

    <Route
      path={CALC_ROUTE_PATHS.vehicleDraft.path}
      element={
        <PageWithPermission
          component={<CalcDraftListContainer key={CALC_ROUTE_PATHS.vehicleDraft.path} type="vehicle" />}
          permissions={[Permission.MTPL_CALCULATE, Permission.CRASH_CALCULATE]}
          anyPermission
        />
      }
    />

    <Route
      path={CALC_ROUTE_PATHS.realtyDraft.path}
      element={
        <PageWithPermission
          component={<CalcDraftListContainer key={CALC_ROUTE_PATHS.realtyDraft.path} type="realty" />}
          permissions={[Permission.REALTY_CALCULATE]}
        />
      }
    />

    <Route
      path={CALC_ROUTE_PATHS.travelDraft.path}
      element={
        <PageWithPermission
          component={<CalcDraftListContainer key={CALC_ROUTE_PATHS.travelDraft.path} type="travel" />}
          permissions={[Permission.TRAVEL_CALCULATE]}
        />
      }
    />

    <Route
      path={CALC_ROUTE_PATHS.records.path}
      element={
        <PageWithPermission
          component={<CalcRecordsContainer />}
          permissions={[
            Permission.ADMIN_MTPL_CALCULATORS,
            Permission.ADMIN_CRASH_CALCULATORS,
            Permission.ADMIN_REALTY_CALCULATORS,
            Permission.ADMIN_TRAVEL_CALCULATORS,
          ]}
          anyPermission
        />
      }
    />

    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </Routes>
);

export default routes;
